import IconRadioChecked from 'assets/icons/radio-checked.svg';
import IconRadioUnchecked from 'assets/icons/radio-unchecked.svg';
import cn from 'classnames';
import React from 'react';

interface Props {
  className?: string;
  content: React.ReactNode;
  dataTest?: string;
  disabled?: boolean;
  hasCircle?: boolean;
  isSelected: boolean;
  variant?: 'default' | 'outlined';
  onClick: () => void;
}

/**
 * It renders a chip with a text for the user to select.
 */
const ChipSelector: React.FC<Props> = ({
  className,
  content,
  dataTest,
  disabled = false,
  hasCircle = false,
  isSelected,
  variant = 'default',
  onClick,
}) => (
  <label
    className={cn(
      'flex h-10 cursor-pointer items-center gap-1.5 rounded-full px-3 py-2.5 text-sm font-normal outline-hidden select-none',
      variant === 'default' && isSelected ? 'bg-primary-main' : 'bg-grey-100',
      variant === 'outlined' &&
        !isSelected &&
        'bg-other-white text-primary-main ring-primary-main ring-1 ring-inset',
      variant === 'outlined' && isSelected && 'bg-primary-main text-text-dark-bg-contrast-white',
      disabled
        ? 'text-text-light-bg-disabled'
        : isSelected
          ? 'text-text-dark-bg-contrast-white'
          : 'text-text-primary',
      className
    )}
    data-test={dataTest}
  >
    <input
      type="radio"
      className="hidden"
      checked={isSelected}
      onClick={onClick}
      disabled={disabled}
    />
    {hasCircle && (
      <>
        {isSelected ? (
          <IconRadioChecked className="text-primary-main h-5 w-5" />
        ) : (
          <IconRadioUnchecked className="text-primary-main h-5 w-5" />
        )}
      </>
    )}
    {content}
  </label>
);

export default ChipSelector;
